// @ts-strict-ignore
import type * as monacoEditor from "monaco-editor/esm/vs/editor/editor.api";

import type { Monaco } from "@components/MonacoHtmlEditor/config/monacoLoader";

const enableTyping = ({
  editor,
  monaco,
}: {
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  monaco: Monaco;
}) => {
  const position = editor.getPosition();
  const selection = editor.getSelection();
  if (!position) {
    return;
  }

  const model = editor.getModel();
  const lineContent = model.getLineContent(position.lineNumber);
  const column = position.column;

  if (column > 1) {
    // When the line has content
    const character = lineContent[column - 2]; // Character before the cursor

    // delete last character
    editor.executeEdits("", [
      {
        range: new monaco.Range(position.lineNumber, column - 1, position.lineNumber, column),
        text: "",
        forceMoveMarkers: true,
      },
    ]);

    // add back last character
    editor.executeEdits("", [
      {
        range: new monaco.Range(position.lineNumber, column - 1, position.lineNumber, column - 1),
        text: character,
        forceMoveMarkers: true,
      },
    ]);
  } else {
    // Handle empty line
    // add a space
    editor.executeEdits("", [
      {
        range: new monaco.Range(position.lineNumber, column, position.lineNumber, column),
        text: " ",
        forceMoveMarkers: true,
      },
    ]);

    // remove the extra space
    editor.executeEdits("", [
      {
        range: new monaco.Range(position.lineNumber, column, position.lineNumber, column + 1),
        text: "",
        forceMoveMarkers: true,
      },
    ]);
  }
  setTimeout(() => {
    editor.setPosition(position); // Restore the cursor position
    editor.setSelection(selection); // Restore the selection
  }, 0);
};

// The typing in Monaco is blocked after right clicking. Only delete key is still working.
// We fixed the typing issue by mimicing the deleting character and re-typing it back.
// Github issue link: https://github.com/microsoft/monaco-editor/issues/4560
export const enableTypingAfterRightClicking = ({
  editor,
  monaco,
}: {
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  monaco: Monaco;
}) => {
  editor.onMouseDown((e) => {
    if (e.event.rightButton) {
      // A slight delay is required to re-enable typing
      setTimeout(() => {
        editor.focus();
        enableTyping({ editor, monaco });
      }, 10);
    }
  });
};
